import { create } from "zustand";
import { PDA1010_R01Card, PDA1010_R01DetailDto } from "./PDA1010_R01Dto";

/** PDA1010_R01 목록·상세·선택 상태를 관리하는 Zustand Store입니다. */
export interface Store_PDA1010_R01 {
  /** 백엔드에서 카드 단위로 그룹화한 최신 측정값 목록 */
  PDA1010_R01List: PDA1010_R01Card[];
  /** 선택한 카드의 차트용 측정 이력 */
  PDA1010_R01DetailList: PDA1010_R01DetailDto[];
  /** 현재 선택되어 상세 차트를 표시 중인 카드 코드 */
  selectedPDA1010_R01CardCode: string | undefined;
  /** 최초 조회 또는 상세 조회의 로딩 여부 */
  isLoading: boolean;
  setPDA1010_R01List: (list: PDA1010_R01Card[]) => void;
  setPDA1010_R01DetailList: (list: PDA1010_R01DetailDto[]) => void;
  setSelectedPDA1010_R01CardCode: (cardCode: string | undefined) => void;
  setIsLoading: (isLoading: boolean) => void;
  /** 화면 이탈 시 목록, 상세, 선택 및 로딩 상태를 초기화합니다. */
  initData: () => void;
}

const usePDA1010_R01Store = create<Store_PDA1010_R01>((set) => ({
  PDA1010_R01List: [],
  PDA1010_R01DetailList: [],
  selectedPDA1010_R01CardCode: undefined,
  isLoading: false,
  setPDA1010_R01List: (PDA1010_R01List) => set({ PDA1010_R01List }),
  setPDA1010_R01DetailList: (PDA1010_R01DetailList) =>
    set({ PDA1010_R01DetailList }),
  setSelectedPDA1010_R01CardCode: (selectedPDA1010_R01CardCode) =>
    set({ selectedPDA1010_R01CardCode }),
  setIsLoading: (isLoading) => set({ isLoading }),
  initData: () =>
    set({
      PDA1010_R01List: [],
      PDA1010_R01DetailList: [],
      selectedPDA1010_R01CardCode: undefined,
      isLoading: false,
    }),
}));

export default usePDA1010_R01Store;
